/* Moomo R2 · search sheet: open/close, focus handling, Shopify predictive search (products + pages). */
(() => {
  const root = document.getElementById('MmSearch');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  const data = JSON.parse(root.querySelector('[data-mm-search-tags]').textContent);
  const input = root.querySelector('#MmSearchInput');
  const clear = root.querySelector('[data-mm-search-clear]');
  const start = root.querySelector('[data-mm-search-start]');
  const results = root.querySelector('[data-mm-search-results]');
  let opener = null; let timer = null; let ctrl = null;

  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = (value) => {
    const cents = Math.round(parseFloat(value) * 100);
    const [w, d] = (cents / 100).toFixed(2).split('.');
    const whole = w.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return data._money.replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole).replace(/\{\{\s*amount\s*\}\}/, `${whole}.${d}`).replace(/<[^>]+>/g, '');
  };

  const open = (e) => {
    opener = e && e.currentTarget ? e.currentTarget : document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('mm-search-locked');
    requestAnimationFrame(() => { root.classList.add('is-open'); input.focus(); });
  };
  const close = () => {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('mm-search-locked');
    setTimeout(() => { root.hidden = true; }, 180);
    if (opener && opener.focus) opener.focus();
  };

  const render = (q, res) => {
    const products = (res.products || []).slice(0, 6);
    const pages = (res.pages || []).slice(0, 4);
    const searchUrl = `${data._url}?q=${encodeURIComponent(q)}&options[prefix]=last`;
    if (!products.length && !pages.length) {
      results.innerHTML = `<p class="mm-search__none">No matches for “${esc(q)}”. Try a style name, or browse all lashes. <a href="${data._shopAll}">Shop all</a></p>`;
      return;
    }
    const prod = products.map((p) => {
      const thumb = data._thumbs[p.handle] || (p.featured_image && p.featured_image.url) || p.image || '';
      const from = p.price_max && p.price_min && p.price_max !== p.price_min ? 'From ' : '';
      const tag = data[p.handle] ? `<span class="mm-search-item__tag">${esc(data[p.handle])}</span>` : '';
      return `<li><a class="mm-search-item" href="${p.url}"><span class="mm-search-item__img">${thumb ? `<img src="${thumb}" alt="" loading="lazy">` : ''}</span><span class="mm-search-item__txt"><span class="mm-search-item__name">${esc(p.title)}</span>${tag}</span><span class="mm-search-item__price">${from}${money(p.price_min || p.price)}</span></a></li>`;
    }).join('');
    const pg = pages.map((p) => `<li><a href="${p.url}">${esc(p.title)}</a></li>`).join('');
    results.innerHTML = `<div class="mm-search__cols">
      ${products.length ? `<div class="mm-search__group mm-search__group--products"><p class="mm-eyebrow mm-text-2">Products</p><ul class="mm-search__list" role="list">${prod}</ul></div>` : ''}
      ${pages.length ? `<div class="mm-search__group mm-search__group--pages"><p class="mm-eyebrow mm-text-2">Pages</p><ul class="mm-search__pages" role="list">${pg}</ul></div>` : ''}
    </div><a class="mm-search__all" href="${searchUrl}">See all results for “${esc(q)}”</a>`;
  };

  const search = (q) => {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    const url = `${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,page&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag`;
    fetch(url, { signal: ctrl.signal }).then((r) => r.json()).then((j) => render(q, j.resources.results)).catch(() => {});
  };

  input.addEventListener('input', () => {
    const q = input.value.trim();
    clear.hidden = !q;
    start.hidden = !!q;
    results.hidden = !q;
    input.setAttribute('aria-expanded', String(!!q));
    clearTimeout(timer);
    if (q) timer = setTimeout(() => search(q), 180);
  });
  clear.addEventListener('click', () => { input.value = ''; input.dispatchEvent(new Event('input')); input.focus(); });
  root.querySelectorAll('[data-mm-search-close]').forEach((b) => b.addEventListener('click', close));
  root.querySelectorAll('[data-mm-term]').forEach((a) => a.addEventListener('click', (e) => {
    e.preventDefault(); input.value = a.dataset.mmTerm; input.dispatchEvent(new Event('input')); input.focus();
  }));
  root.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    const f = [...root.querySelectorAll('a[href], button:not([hidden]), input:not([type="hidden"])')].filter((el) => el.offsetParent !== null);
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  document.addEventListener('click', (e) => { const b = e.target.closest('.mm-search-open'); if (b) { e.preventDefault(); open({ currentTarget: b }); } });
})();
